module.exports = __webpack_public_path__ + "static/media/desktop-icons-buttons-pagination-left-arrow-default.2c838a82.svg";